export const concatPathWithBackendUrl = (path) => {
    if (typeof path !== "string" || path.trim() === "") return "";
  
    if (path.includes("http")) {
      return path;
    } else {
      return `${process.env.REACT_APP_API_BASE_URL}/uploads/${path}`;
    }
  };
  